import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import Upgrade401kModal from "../components/Upgrade401kModal";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar, faChartLine, faChartSimple, faPercentage, faUsd, faInfoCircle, faRotate, faLongArrowAltRight, faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import Line3 from "../components/chart/Line3";
import { getCurrencySymbol, formatCurrency, getRate } from '../utils/currencyUtils';
import { toast } from 'react-hot-toast';

function Contribution() {
  const { user } = useUser();
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
    };
    fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [crypto, setCrypto] = useState([]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          amount: 0,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  const [totalSavings, setTotalSavings] = useState(0);  
  const [enrollment, setEnrollment] = useState([]);
  const [savingshistory, setSavingsHistory] = useState([]);
  const formatMonth = (date) => {
    const options = { month: 'short' };
    return new Intl.DateTimeFormat('en-US', options).format(date);
  };
  const processSavingsDataByMonth = (savings) => {
    const monthlyData = {};
    savings.forEach(saving => {
          console.log(saving.amountUSD)
      const savingDate = new Date(saving.date);
      const monthKey = `${savingDate.getFullYear()}-${String(savingDate.getMonth() + 1).padStart(2, '0')}`;
      if (!monthlyData[monthKey]) {
        monthlyData[monthKey] = 0;
      }
      monthlyData[monthKey] += parseFloat(saving.amountUSD);
    });  
    const labels = [];
    const data = [];
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 7);
    for (let i = 0; i < 8; i++) {
      const monthKey = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
      labels.push(formatMonth(currentDate));
      data.push(monthlyData[monthKey] || 0);
      currentDate.setMonth(currentDate.getMonth() + 1);
    }
    return { labels, data };
  };
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchsavings: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        const updatedSavings = data.savings.map(tx => {
          const coinName = tx.method.split(" - ")[0];
          let logo = null;
          let symbol = null;
          let amountUSD = null;
          const asset = crypto.find(asset => asset.name === coinName);
          if (asset) {
            logo = asset.logo;
            symbol = asset.symbol;
            amountUSD = asset.price * tx.amount;
          }
          return {
            ...tx,
            logo,
            symbol,
            amountUSD
          };
        });
        setSavingsHistory(updatedSavings);
        const amounts = updatedSavings.map(item => parseFloat(item.amountUSD) || 0);
        const total = amounts.reduce((sum, n) => sum + n, 0);
        setTotalSavings(total);
      }
    })
    .catch(err => {
    })
  }, [user, crypto]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchEnrollment: true })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
          setEnrollment(data.enrollment)
        }
    })
    .catch(err => {
    })
  }, [user, crypto]);
  const [savingsChartData, setSavingsChartData] = useState({ labels: [], data: [] });
  useEffect(() => {
    const { labels, data } = processSavingsDataByMonth(savingshistory);
    setSavingsChartData({ labels, data });
  }, [savingshistory]);

  const [loading, setLoading] = useState(false);
  const rebalance = () => {
    setLoading(true)
    setTimeout(() => {
      toast.success("Portfolio Rebalanced");
      setLoading(false);
    }, 3000);
  }

  if (!enrollment || typeof enrollment !== 'object' || Object.keys(enrollment).length === 0) {
    return <div style={{ textAlign: "center", marginTop: "20%" }}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Upgrade401kModal UserDetails={user} enrollment={enrollment} />
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Performance" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar"> 
          <Header title="Performance" icon={<FontAwesomeIcon icon={faChartSimple} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main className="container mb-5">
            <h2 className="mt-3 mb-0" style={{fontWeight:'900'}}>Performance</h2>
            <p class="mb-0" style={{fontSize: '14px'}}>Track your portfolio performance and analyze investment returns</p>
            <div className="row">
                <div className="col-lg-8 g-4">
                    <div className="mycard p-3 overflow-hidden" style={{border:'1px solid #a9a9a90f'}}>
                        <div className="d-flex align-items-center">
                            <FontAwesomeIcon icon={faChartLine} className="text-info" style={{fontSize: '18px'}} />
                            <h5 className="mb-0 ms-2" style={{fontWeight:'900'}}>Performance Overview</h5>
                        </div>
                        <div className="row">
                            <div className="col-lg-3 col-md-6 g-4">
                                <div className="p-3 d-flex flex-column align-items-center rounded-3" style={{backgroundColor:'#ff6b3509'}}>
                                    <FontAwesomeIcon icon={faUsd} className="text-prime mb-2" style={{fontSize: '18px'}} />
                                    <h4 className="mb-0" style={{fontWeight:'900'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(user?.savings * rate)}</h4>
                                    <p className="mb-0 text-prime" style={{fontSize:'12px'}}>Current Balance</p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 g-4">
                                <div className="p-3 d-flex flex-column align-items-center rounded-3" style={{backgroundColor:'#19875411'}}>
                                    <FontAwesomeIcon icon={faChartLine} className="text-success mb-2" style={{fontSize: '18px'}} />
                                    <h4 className="mb-0" style={{fontWeight:'900'}}>+{getCurrencySymbol(user?.currency)}{formatCurrency(user?.savings_gain * rate)}</h4>
                                    <p className="mb-0 text-success" style={{fontSize:'12px'}}>Total Return</p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 g-4">
                                <div className="p-3 d-flex flex-column align-items-center rounded-3" style={{backgroundColor:'#0dcaf012'}}>
                                    <FontAwesomeIcon icon={faPercentage} className="text-info mb-2" style={{fontSize: '18px'}} />
                                    <h4 className="mb-0" style={{fontWeight:'900'}}>+{formatCurrency(Number(user?.savings_gain) > 0 ? (totalSavings + Number(user?.employee_match))/Number(user?.savings_gain) : 0)}%</h4>
                                    <p className="mb-0 text-info" style={{fontSize:'12px'}}>Return %</p>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 g-4">
                                <div className="p-3 d-flex flex-column align-items-center mycard">
                                    <FontAwesomeIcon icon={faCalendar} className="mb-2" style={{fontSize: '18px'}} />
                                    <h4 className="mb-0" style={{fontWeight:'900'}}>12m</h4>
                                    <p className="mb-0 text-secondary" style={{fontSize:'12px'}}>Time Period</p>
                                </div>
                            </div>
                        </div>
                        <div style={{marginLeft:'-8%'}}>
                          <Line3 linename1="Savings" label={savingsChartData.labels} linedata1={savingsChartData.data}/>
                        </div>
                    </div>
                </div>
                <div className="col-lg-4 g-4">
                  <div className="mycard p-3" style={{border:'1px solid #a9a9a90f'}}>
                      <div className="d-flex align-items-center">
                          <FontAwesomeIcon icon={faRotate} className="text-prime" style={{fontSize: '18px'}} />
                          <h5 className="mb-0 ms-2" style={{fontWeight:'900'}}>Rebalance Tools</h5>
                      </div>
                      <div className="rounded-3 p-3 mt-3 mb-4" style={{backgroundColor:'#ff6b3509',border:'1px solid #ff6b3563'}}>
                          <p className="mb-0 text-prime fw-semibold" style={{fontSize:'14px'}}><FontAwesomeIcon icon={faInfoCircle} className="me-2" style={{fontSize: '14px'}} /> Rebalancing Recommended</p>
                          <p className="mb-0 text-prime " style={{fontSize:'14px'}}>Some funds have drifted from target allocations.</p>
                      </div>
                      <p className="mb-3 fw-semibold">Target vs Current Allocation</p>
                      <div className="mb-1 d-flex align-items-center justify-content-between">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Large Cap Stock Index</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>{Number(enrollment.stocks)}% <FontAwesomeIcon icon={faLongArrowAltRight} className="mx-2" style={{fontSize: '12px'}} /> <span className="text-prime">50%</span></p>
                      </div>
                      <div className="rounded-pill w-100 mb-2" style={{height:'10px',backgroundColor:'#ffffff1e'}}>
                        <div className="rounded-pill h-100 bg-prime" style={{width:Number(enrollment.stocks)+'%'}}></div>
                      </div>
                      <div className="mb-1 d-flex align-items-center justify-content-between">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Bond Index Fund</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>{Number(enrollment.bonds)}% <FontAwesomeIcon icon={faLongArrowAltRight} className="mx-2" style={{fontSize: '12px'}} /> <span className="text-success">10%</span></p>
                      </div>
                      <div className="rounded-pill w-100 mb-2" style={{height:'10px',backgroundColor:'#ffffff1e'}}>
                        <div className="rounded-pill h-100 bg-success" style={{width:Number(enrollment.bonds)+'%'}}></div>
                      </div>
                      <div className="mb-1 d-flex align-items-center justify-content-between">
                        <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Stable Value (Cash Reserve)</p>
                        <p className="mb-0" style={{fontSize:'14px'}}>{Number(enrollment.cash)}% <FontAwesomeIcon icon={faLongArrowAltRight} className="mx-2" style={{fontSize: '12px'}} /> <span className="text-success">5%</span></p>
                      </div>
                      <div className="rounded-pill w-100 mb-2" style={{height:'10px',backgroundColor:'#ffffff1e'}}>
                        <div className="rounded-pill h-100 bg-success" style={{width:Number(enrollment.cash)+'%'}}></div>
                      </div>
                      <div className="py-2 myBtn text-center fw-semibold mt-4" onClick={rebalance} style={{cursor:'pointer',fontSize:'14px'}}><FontAwesomeIcon icon={faRotate} style={{fontSize: '12px'}} spin={loading} /> {loading?'Rebalancing...':'Rebalance Now'}</div>
                      <div className="py-2 rounded-3 text-center fw-semibold mt-2" style={{border:'1px solid #ff6b3570',cursor:'pointer',fontSize:'14px'}}>Schedule Auto-Rebalancing</div>
                      <div className="p-3 rounded-3 fe-semibold mt-4" style={{border:'1px solid #ff6b3570'}}>
                        <p className="mb-0 fw-semibold mb-2">Estimated Impact</p>
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Transaction fee:</p>
                          <p className="mb-0" style={{fontSize:'14px'}}>{getCurrencySymbol(user?.currency)}0.00</p>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                          <p className="mb-0 text-secondary" style={{fontSize:'14px'}}>Tax impact:</p>
                          <p className="mb-0 text-success fw-semibold" style={{fontSize:'14px'}}>None (401k)</p>
                        </div>
                      </div>
                  </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Contribution